import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

const SchoolSidenav = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-sidenav sidenav layout-box o-has-rows mb-6">
      <div className="sidenav-filter-wrapper">
        <ul className="sidenav-list">
          <li>
            <Link href="/school/learn-spoken-english" className="sidenav-item">
              {t('title.school.short.overview')}
            </Link>
          </li>
          <li>
            <Link href="/school/certified-teachers" className="sidenav-item">
              {t('title.school.short.certifiedTeachers')}
            </Link>
          </li>
          <li>
            <Link href="/school/effective-classes" className="sidenav-item">
              {t('title.school.short.effectiveClasses')}
            </Link>
          </li>
          <li>
            <Link href="/school/getting-started" className="sidenav-item">
              {t('title.school.short.gettingStarted')}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SchoolSidenav;
